import { useMutation } from '@tanstack/react-query';
import { exportMaintenanceTickets } from '../../../api/maintenance';

interface ExportParameters {
  organizationId?: string;
  systemId?: string;
  search?: string;
  status?: string;
  tags?: string;
}

function useExportMaintenanceTickets(options?: {}) {
  return useMutation({
    mutationFn: (parameters: ExportParameters) => exportMaintenanceTickets(parameters),
    ...options,
  });
}

export default useExportMaintenanceTickets;
